import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <Reveal>
        <div className="flex items-center gap-3 mb-5">
          <span className="h-px w-8 bg-gold" />
          <span className={`label-caps ${light ? "text-gold" : "text-navy"}`}>{eyebrow}</span>
        </div>
      </Reveal>
    )}
    <Reveal delay={0.05}>
      <h2 className={`text-3xl md:text-4xl lg:text-5xl font-black tracking-tight leading-[1.1] ${light ? "text-offwhite" : "text-navy"}`}>
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.1}>
        <p className={`mt-5 text-base md:text-lg leading-relaxed ${light ? "text-offwhite/75" : "text-charcoal/80"}`}>
          {intro}
        </p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
